<template>
  <div class="dashboard">
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar hide">
      <ul class="page-breadcrumb">
        <li>
          <i class="icon-home"></i>
          <router-link to="/workspace/">Workspace</router-link>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <span>Organization Forms</span>
        </li>
      </ul>
      <div class="page-toolbar hide">
        <div class="btn-group pull-right">
          <button type="button" class="btn btn-fit-height grey-salt dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-delay="1000" data-close-others="true" aria-expanded="false"> Widgets
            <i class="fa fa-angle-down"></i>
          </button>
          <ul class="dropdown-menu pull-right module-zone" role="menu">
            <widget :name="widgets.widgetsStash" :type="'widgetsStash'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
          </ul>
        </div>
      </div>
    </div>
    <breadcrumb-bar :crumbs="['Organization Forms']"></breadcrumb-bar>
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-4 db-column" id="first-column">
        <widget :name="widgets.widgetsFirst" :type="'widgetsFirst'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
      </div>
      <div class="col-md-4 db-column" id="second-column">
        <widget :name="widgets.widgetsSecond" :type="'widgetsSecond'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP, ERROR, updateUserInfo } from '@/http-common';
  import draggable from 'vuedraggable';
  import Widget from '@/components/widgets/Widget.vue';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'organizationForms',
    components: {
      draggable,
      widget: Widget,
      'breadcrumb-bar': Breadcrumbs
    },
    data () {
      return {
        widgets: (JSON.parse(localStorage.getItem('user_account')).settings.workspace_widgets == null) ? JSON.parse('{\"widgetsFirst\":[{\"id\":\"1\",\"name\":\"OrganizationForms\"}],\"widgetsSecond\":[{\"id\":\"2\",\"name\":\"GeneralForms\"}],\"widgetsStash\":[]}') : JSON.parse(JSON.parse(localStorage.getItem('user_account')).settings.workspace_widgets),
        portlet: '',
      }
    },
    beforeMount() {
      this.loadWorkspace();
    },
    computed: {
      ...mapGetters({
        workspace: 'getWorkspace',
      })
    },
    methods: {
      ...mapActions({
        loadWorkspace:'loadWorkspace'
      }),
      widgetsData(data) {
        Object.keys(this.widgets).forEach((obj) => {
          if(obj === data['0']) {
            this.widgets[obj] = data['1'];
          }
        });
        this.saveData();
      },
      saveData: _.debounce(
        function () {
          HTTP.post(`users/settings`, {name: 'workspace_widgets', value: JSON.stringify(this.widgets)})
            .then(response => {
              ERROR(response);
              if(response.data.status == 'success') {
                updateUserInfo('settings', {"widgets": JSON.stringify(this.widgets)});
              }
            })
            .catch(err => {
              console.log(err);
            })
        }),
    },
    watch: {
      // '$route.params.id': function () {
      //   this.loadParticipant(this.$route.params.id);
      // }
    }
  }
</script>
<style scoped>
  .flip-list-move {
    transition: transform 0.5s;
  }
  .db-column > div, .db-column > div > span {
    min-height: 50vh;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// Workspace.vue?51fa3d68